"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ledro": {
    "acf98fe5": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "barcesino": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1ece43de": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "concei": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "506ec0b2": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "degara": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cf2196e2": [{
      "hkey": "8d125ce7",
      "slug": "molina-di-ledro",
      "name": "Molina di Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "legos": [{
      "hkey": "8d125ce7",
      "slug": "molina-di-ledro",
      "name": "Molina di Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ledro"
    }],
    "cb590c78": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "moi": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "052fc528": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "fd0c5cd9",
      "slug": "ledro",
      "name": "Ledro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;